/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Folder } from '@material-ui/icons';
import { filesAPI } from 'src/api/modules/files';
import notice from 'src/common/components/Notice';
import BaseModal from 'src/common/components/Modal';
import FullTable from 'src/common/components/FullTable';
import { download } from 'src/pages/Files/UpaloadFileMinos';
import { downloadZip } from 'src/pages/Files/UpaloadFileMinos';
import CustomButton from 'src/common/components/CustomButton';
import { columnsRecord2 } from 'src/pages/Sessions/utils/list_data';
import { ZipComponentModal } from 'src/pages/Sessions/ZipComponentModal';

const FileVersions = ({
	open,
	setClose,
	user,
	pointData,
	fileDetail,
	downloadMigrated,
}) => {
	const [getZip, setGetZip] = useState(false);
	const [fileHistory, setFileHistory] = useState([]);
	const [descargados, setDescargados] = useState(0);
	const [totales, setTotales] = useState(0);
	const porcentaje = totales > 0 ? Math.round((descargados / totales) * 100) : 0;
	const [isDownloading, setIsDownloading] = useState(false);

	useEffect(() => {
		if (fileDetail !== undefined) getFiles(fileDetail.name);
	}, [fileDetail]);

	const onDownload = (file) => {
		if (file.migrado === true) downloadMigrated(file);
		else
			download(
				file.ruta,
				file.nombre,
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
				undefined,
				'punto ' +
					fileDetail.orderNum +
					' de ' +
					fileDetail.session +
					' desde historial de archivo'
			);
	};

	const getFiles = (nameFile) => {
		setFileHistory([]);
		filesAPI
			.getFileHistory('ORDENDIA', pointData.id, pointData.isMigrated, 'H', nameFile)
			.then((response) => {
				let fileVersions = [];
				response.forEach((item) => {
					fileVersions.push({
						...item,
						hora: item.fecha,
					});
				});

				setFileHistory(fileVersions);
			})
			.catch((e) => {
				notice('Ocurrio un error al cargar el historial del archivo');
			});
	};

	const downloadVersionsZip = () => {
		setIsDownloading(true);
		setGetZip(true);
		setTotales(fileHistory.length);
		downloadZip(
			fileHistory,
			user,
			setGetZip,
			fileDetail.name,
			false,
			setDescargados,
			setIsDownloading,
			descargados,
			setTotales,
			'H'
		);
	};

	return (
		<BaseModal
			open={open}
			onClose={setClose}
			onCancel={setClose}
			maxWidth="lg"
			cancelLabel="cerrar"
			mainText="Historial de Archivo"
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'flex-end',
					width: '100%',
					justifyContent: 'flex-end',
				}}
			>
				{isDownloading ? (
					<ZipComponentModal
						descargados={descargados}
						totales={totales}
						porcentaje={porcentaje}
					/>
				) : (
					<CustomButton
						mainText={'Descarga masiva'}
						onClick={() => {
							downloadVersionsZip();
						}}
						className={'float-right'}
						disabled={getZip}
						icon={Folder}
						loading={getZip}
					/>
				)}
			</div>
			<FullTable
				title={'Archivo: ' + fileDetail.name}
				items={fileHistory}
				columns={columnsRecord2(onDownload)}
			/>
		</BaseModal>
	);
};

export default FileVersions;
